












import Enumerable from "linq";
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { DomainRegistry } from "../../../domain";
import { Directory } from "../../../domain/drawing";
import { FormatReference } from "../../../domain/format";
import { FilterableMasterSelectableMixin } from "../../system/selectors/mixins";
import MultiOptionListBoxSelector from "../../system/selectors/MultiOptionListBoxSelector.vue";

@Component({
  components: {
    MultiOptionListBoxSelector,
  },
})
export default class MultiFormatListSelector extends Mixins(FilterableMasterSelectableMixin) {
  values: FormatReference[];

  @Prop({ default: false })
  shouldIgnoreChained: boolean;

  @Prop({ default: false })
  shouldIncludeReferenceableGroupFormats: boolean;

  created() {
    this.loadFormats();
  }

  @Watch("shouldIncludeReferenceableGroupFormats")
  onShouldIncludeReferenceableGroupFormatsUpdated(): void {
    // よほどのことが無い限りはここは通らない見込みだが念のため対応している
    this.values = null;
    this.loadFormats();
  }

  private async loadFormats(): Promise<void> {
    try {
      const repository = DomainRegistry.format.getFormatRepository();
      const formats = await repository.getFormats(this.shouldIgnoreChained, this.shouldIncludeReferenceableGroupFormats);
      this.values = this.toArray(formats);
    } catch (e) {
      this.$error(this.$wording.format.name + "情報取得失敗", this.$wording.format.name + "情報を取得できませんでした。", e);
    }
  }

  toArray(source: Directory<string, FormatReference>[]): FormatReference[] {
    return Enumerable.from(source)
      .select(s => this.directoryToArray(s))
      .aggregate([], (s, f) => s.concat(f));
  }

  directoryToArray(source: Directory<string, FormatReference>): FormatReference[] {
    return Enumerable.from(source.entities)
      .concat(this.toArray(source.nodes))
      .toArray();
  }
}
